import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import _pick from "lodash/pick";
import { Table } from "src/requests/table/types";
import { GetOverviwTablesForTemplateIds } from "src/components/molecules/TableExportForm/types";
import { fetchOverviewTablesThunk } from "./thunks";
import {
  useOverviewTablesById,
  useOverviewTablesForTemplateIds,
} from "./useSelectors";
import { getMissingTableTemplateIds } from "./utils";

export const useFetchOverviewTables = () => {
  const dispatch = useDispatch();

  return useCallback(
    (templateIds: number[]) => dispatch(fetchOverviewTablesThunk(templateIds)),
    [dispatch]
  );
};

export const useOverviewTableForTemplateIdAutoFETCH = (
  templateId: number
): Table | undefined => {
  const [triesCount, setTriesCount] = useState(0);
  const fetchOverviewTables = useFetchOverviewTables();
  const overviewTables = useOverviewTablesForTemplateIds([templateId]);

  useEffect(() => {
    if (triesCount > 1) return;

    const missingTemplateIds = getMissingTableTemplateIds(overviewTables);
    if (missingTemplateIds.length) {
      fetchOverviewTables(missingTemplateIds);
      setTriesCount((prev) => prev + 1);
    }
  }, [overviewTables, fetchOverviewTables, triesCount]);

  return overviewTables[templateId];
};

export const useGetOverviewTablesForTemplateIds =
  (): GetOverviwTablesForTemplateIds => {
    const overviewTablesById = useOverviewTablesById();

    const getOverviewTablesByIds: GetOverviwTablesForTemplateIds = useCallback(
      (templateIds: number[]) => _pick(overviewTablesById, templateIds),
      [overviewTablesById]
    );

    return getOverviewTablesByIds;
  };
